"use client"
import React from 'react'
import moment from 'moment'
import { useRouter } from 'next/navigation'
import { formatToBRL } from '@/helpers/formatter'

import { orange } from '@mui/material/colors'
import { Box, Typography } from '@mui/material'

const statusEnum = {
    "pending": "Pendente",
    "error": "Erro",
    "expired": "Expirado",
    "paid": "Pago",
    "manual": "Pago"
}

const statusColor = {
    "pending": orange[600],
    "error": "error",
    "expired": "error",
    "paid": "primary",
    "manual": "primary"
}

export default function PaymentItem({
    quantity,
    value,
    title,
    status,
    date,
    identifier,
    image
}) {
    const router = useRouter();

    return (
        <Box sx={{
            cursor: "pointer",
            mb: 1,
            display: "flex",
            gap: 1,
            boxShadow: "rgba(145, 158, 171, 0.2) 0px 0px 2px 0px, rgba(145, 158, 171, 0.12) 0px 12px 24px -4px",
            borderRadius: 1
        }}
            onClick={() => {
                if (status == "paid" || status == "manual") {
                    router.push(`/payment/${identifier}/success/`);
                }
                else if (status == "pending" || status == "error" || status == "expired") {
                    router.push(`/payment/${identifier}`);
                }
            }}
        >
            <img style={{ maxWidth: 120, minWidth: 120, maxHeight: 100, objectFit: "cover", borderRadius: "10px 0  0 10px" }}
                src={image} />
            <Box sx={{ maxHeight: 100, display: "flex", flexDirection: "column", py: 1 }}>
                <Typography variant='caption' sx={{ fontSize: 9, color: "rgba(0,0,0,.7)" }}>{moment(date).format('DD/MM/YYYY')} ás {moment(date).format('HH:mm')}</Typography>
                <Typography variant='subtitle2'>{title.length > 30 ? title.substr(0, 30) + "..." : title}</Typography>
                <Typography variant='caption' color={status && statusColor[status]} sx={{ fontSize: 9 }} fontWeight={600}>{status && statusEnum[status]}</Typography>
                <Typography variant='caption' sx={{ fontSize: 9 }}>Quantidade: {quantity}</Typography>
                <Typography variant='caption' sx={{ fontSize: 9 }}>Valor: {formatToBRL(value)}</Typography>
            </Box>
        </Box>
    )
}
